import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=2f0a3bc1&scoped=true&"
import script from "./permission.vue?vue&type=script&lang=ts&"
export * from "./permission.vue?vue&type=script&lang=ts&"
import style0 from "./permission.vue?vue&type=style&index=0&id=2f0a3bc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a3bc1",
  null
  
)

export default component.exports